<template>
  <div class="bg-dark">
  <nav class="navbar navbar-dark justify-content-between container">
    <ul class="nav nav-pills">
      <li class="nav-item">
        <router-link to="/" class="nav-link">{{ insert[lang].catalog }}</router-link>
      </li>
      <li class="nav-item">
        <router-link to="/add" class="nav-link">{{ insert[lang].addAuto }}</router-link>
      </li>
      <li v-if="$store.state.isAuth" class="nav-item">
        <div class="nav-link" @click="logout">{{ insert[lang].logout }}</div>
      </li>
    </ul>
    <ul class="nav nav-pills">
      <li class="nav-item">
        <button @click="this.$store.dispatch('SaveLanguage', 'en')" class="btn3 mr-6" :disabled="$store.state.isProdsLoading || $store.state.updProdFreeze ">
          <img :src=" define.pathToGraphics + '/flags/en.png' " class="mr-6">
          English</button>
      </li>
      <li class="nav-item">
        <button @click="this.$store.dispatch('SaveLanguage', 'uk')" class="btn3" :disabled="$store.state.isProdsLoading || $store.state.updProdFreeze ">
          <img :src=" define.pathToGraphics + '/flags/ua.png' " class="mr-6">
          Украинский</button>
      </li>
    </ul>
    <ul class="nav nav-pills">
      <li class="nav-item">
        <router-link to="/about" class="nav-link">{{ insert[lang].about }}</router-link>
      </li>
    </ul>
  </nav>
  </div>
</template>

<script>
import useAuth from '@/hooks/useAuth'
import insert from '@/data/languages/NavBarData.js'
import useLang from '@/hooks/useLang'
import { define } from '@/data/globals.js'

export default {
  setup() {
    const { logout } = useAuth()
    const { lang } = useLang()

    return { logout, lang, insert, define }
  }
}
</script>

<style>
.nav-link:hover {
  cursor: pointer;
}
</style>
